import { useConfiguration } from '../../../../store/configurationStore';
import { InstrumentConfig, UIInstrumentType } from '../types';

export const useInstrumentConfig = () => {
  const {
    templates,
    activeTemplateId,
    activeInstrumentType,
    setActiveInstrumentType,
  } = useConfiguration();

  // Get the active template
  const activeTemplate = templates.find(t => t.id === activeTemplateId) || null;

  // Get all instrument configs for active template
  const instrumentConfigs = activeTemplate?.instrumentConfigs || [];

  // Get the active instrument config
  const activeInstrumentConfig =
    instrumentConfigs.find(ic => ic.instrumentType === activeInstrumentType) ||
    null;

  // Select an instrument type
  const selectInstrumentType = (type: UIInstrumentType): void => {
    if (!activeTemplateId) {
      throw new Error('⚠️ No active template selected');
    }

    setActiveInstrumentType(type);
  };

  // Get instrument config by type
  const getInstrumentConfig = (
    type: UIInstrumentType
  ): InstrumentConfig | null => {
    return instrumentConfigs.find(ic => ic.instrumentType === type) || null;
  };

  return {
    instrumentConfigs,
    activeInstrumentType,
    activeInstrumentConfig,
    selectInstrumentType,
    getInstrumentConfig,
  };
};
